/**
 * taxValidation.js
 * TR Vergi Kimlik No (VKN) ve TC Kimlik No (TCKN) doğrulama algoritmaları.
 * Java ve C# referans implementasyonlarından JavaScript'e çevrilmiştir.
 * Backend ve frontend'de aynı dosya kullanılabilir (Node.js / browser).
 */

/**
 * Türkiye Vergi Kimlik Numarası (VKN) doğrulama
 * Referans: Gelir İdaresi Başkanlığı checksum algoritması
 * @param {string} vkn - 10 haneli VKN
 * @returns {boolean}
 */
export function validateVKN(vkn) {
  if (!vkn || typeof vkn !== 'string') return false;
  const cleaned = vkn.replace(/\s/g, '');
  if (!/^\d{10}$/.test(cleaned)) return false;

  const lastDigit = parseInt(cleaned[9], 10);
  let sum = 0;

  for (let i = 0; i < 9; i++) {
    const digit = parseInt(cleaned[i], 10);
    const tmp = (digit + 10 - (i + 1)) % 10;
    if (tmp === 9) {
      sum += tmp;
    } else {
      sum += (tmp * Math.pow(2, 10 - (i + 1))) % 9;
    }
  }

  return lastDigit === (10 - (sum % 10)) % 10;
}

/**
 * Türkiye Cumhuriyeti Kimlik Numarası (TCKN) doğrulama
 * Referans: Nüfus ve Vatandaşlık İşleri Genel Müdürlüğü checksum algoritması
 * @param {string} tcNo - 11 haneli TCKN
 * @returns {boolean}
 */
export function validateTCKN(tcNo) {
  if (!tcNo || typeof tcNo !== 'string') return false;
  const cleaned = tcNo.replace(/\s/g, '');
  if (!/^\d{11}$/.test(cleaned)) return false;
  if (cleaned[0] === '0') return false; // İlk hane 0 olamaz

  const digits = cleaned.split('').map(Number);

  // Tek indeksli (0,2,4,6,8) rakamların toplamı * 7
  const evenSum = digits.filter((_, i) => i % 2 === 0 && i < 9).reduce((a, b) => a + b, 0);
  // Çift indeksli (1,3,5,7) rakamların toplamı
  const oddSum  = digits.filter((_, i) => i % 2 === 1 && i < 9).reduce((a, b) => a + b, 0);

  // 10. hane kontrolü
  if ((evenSum * 7 - oddSum) % 10 !== digits[9]) return false;
  // 11. hane kontrolü
  if (digits.slice(0, 10).reduce((a, b) => a + b, 0) % 10 !== digits[10]) return false;

  return true;
}
